module.exports = __webpack_public_path__ + "static/img/titleBg.a361793e.png";